export function isAbortError(error: unknown): boolean {
  return !!error && (error as any).name === "AbortError";
}
